import React from "react";
import "./App.css";
import { Home } from "./pages/Home";
import { Contact } from "./pages/Contact";
import { Locations } from "./pages/Locations";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Book } from "./pages/Book";
import { Dubai } from "./pages/locations/Dubai/Dubai";

import { Goa } from "./pages/locations/Goa/Goa";
import { RihandDam } from "./pages/locations/RihandDam/RihandDam";

import { Error } from "./pages/Error";
import { MukhaFall } from "./pages/locations/MukhaFall/MukhaFall";
import  TopPlace from "./pages/TopPlace";
import { FossilsPark } from "./pages/locations/FossilsPark/FossilsPark";
import { ShivDwarTemple } from "./pages/locations/ShivDwarTemple/ShivDwarTemple";
import { VijaygarhFort } from "./pages/locations/VijaygarhFort/VijaygarhFort";
import { Cavepaintings } from "./pages/locations/Cavepaintings/Cavepaintings";
import AboutUs from "./pages/AboutUs";
import { Hotel } from "./pages/Hotel";
import {Packages} from "./pages/Packages";
import { AgoriFort } from "./pages/locations/AgoriFort/AgoriFort";
import { Aabadi } from "./pages/locations/Aabadi/Aabadi";
import { Khanta } from "./pages/locations/Khanta/Khanta";
import { LakhaniyaDari } from "./pages/locations/LakhaniyaDari/LakhaniyaDari";
import { NaugarhWaterfall } from "./pages/locations/NaugarhWaterfall/NaugarhWaterfall";
import { DhandhraulDam } from "./pages/locations/DhandhraulDam/DhandhraulDam";
import { Mangleshwar } from "./pages/locations/Mangleshwar Mahadev Temple/Mangleshwar";
import { ShriRenukeshwar } from "./pages/locations/ShriRenukeshwar/ShriRenukeshwar";
import { HathinalaBiodiversity } from "./pages/locations/HathinalaBiodiversity/HathinalaBiodiversity";
import { ObraDam } from "./pages/locations/Obra Dam/ObraDam";
import { KaimoorWildlife } from "./pages/locations/KaimoorWildlife/KaimoorWildlife";
import { SonEcoPoint } from "./pages/locations/Son Eco Point/SonEcoPoint";
import { Rajdari } from "./pages/locations/Rajdari/Rajdari";
import { NagwaDam } from "./pages/locations/Nagwadam/NagwaDam";
import { Dongia } from "./pages/locations/Dongia/Dongia";
import ScrollToTop from "./components/ScrollToTop";
import ArticlePage from "./pages/ArticlePage";
import { Varanasi } from "./pages/locations/Varanasi/varanasi";
import { Allahabad } from "./pages/locations/Allahabad/Allahabad";
import { MaaMundeshwari } from "./pages/locations/Maa Mundeshwari/MaaMundeshwari";
import { Vindhyachal } from "./pages/locations/Vindhyachal Temple/vindhyachal";
import { SonbhadraPage } from "./pages/SonbhadraPage";

function App() {
  return (
    <div className="App">
      <Router>
      <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/book" element={<Book />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/locations" element={<Locations />} />
          <Route path="/topplace" element={<TopPlace />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/hotels" element={<Hotel />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/article" element={<ArticlePage />} />
          <Route path="/locations/abadipicnic" element={<Aabadi />} />
          <Route path="/locations/agorifort" element={<AgoriFort />} />
          <Route path="/locations/cavepaintings" element={<Cavepaintings />} />
          <Route path="/locations/khanta" element={<Khanta />} />
          <Route path="/locations/shivdwartemple" element={<ShivDwarTemple />} />
          <Route path="/locations/fossilspark" element={<FossilsPark />} />
          <Route path="/locations/rihanddam" element={<RihandDam />} />
          <Route path="/locations/vijaygarhfort" element={<VijaygarhFort />} />
          <Route path="/locations/mukhafall" element={<MukhaFall />} />
          <Route path="/locations/lakhaniyadari" element={<LakhaniyaDari />} />
          <Route path="/locations/naugarhwaterfall" element={<NaugarhWaterfall />} />
          <Route path="/locations/dhandhrauldam" element={<DhandhraulDam />} />
          <Route path="/locations/mangleshwarmahadev" element={<Mangleshwar />} />
          <Route path="/locations/renukeshwar" element={<ShriRenukeshwar />} />
          <Route path="/locations/hathinalabiodiversity" element={<HathinalaBiodiversity />} />
          <Route path="/locations/obradam" element={<ObraDam />} />
          <Route path="/locations/kaimoor-wildlife-sanctuary" element={<KaimoorWildlife />} />
          <Route path="/locations/son-ecopoint" element={<SonEcoPoint />} />
          <Route path="/locations/devdari-rajdari-waterfall" element={<Rajdari />} />
          <Route path="/locations/nagwadam-silhat-dam" element={<NagwaDam />} />
          <Route path="/locations/dongia-picnic-spot" element={<Dongia />} />
          <Route path="/locations/varanasi-kashi" element={<Varanasi />} />
          <Route path="/locations/allahabad-prayagraj" element={<Allahabad />} />
          <Route path="/locations/mundeshwari" element={<MaaMundeshwari />} />
          <Route path="/locations/vindhyachal" element={<Vindhyachal />} />
          <Route path="/sonbhadra" element={<SonbhadraPage />} />


          <Route path="*" element={<Error/>} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
